import { create } from 'zustand'

interface UIState {
  isAddPickOpen: boolean
  setIsAddPickOpen: (open: boolean) => void
  isAddCollectionOpen: boolean
  setIsAddCollectionOpen: (open: boolean) => void
}

export const useUIStore = create<UIState>((set) => ({
  isAddPickOpen: false,
  setIsAddPickOpen: (open) => set({ isAddPickOpen: open }),
  isAddCollectionOpen: false,
  setIsAddCollectionOpen: (open) => set({ isAddCollectionOpen: open }),
}))
